<template>
  <div class="wrapper">
    <div style="display: flex; align-items: center;">
      <!-- <el-button
        v-if="$route.query.isJRZL === '1'"
        style="margin-right: 10px;"
        type="primary"
        icon="icon-ccui-return"
        @click="back"
        >返回</el-button
      > -->
      <!-- <el-divider
        v-if="$route.query.isJRZL === '1'"
        direction="vertical"
      ></el-divider> -->
      <base-bread-crumb
        :currBreadCrumb="currBreadCrumb"
        :isShowPortal="false"
      ></base-bread-crumb>
    </div>
    <div class="ccui-home-app-container-detail">
      <div class="ccui-app-container announcementDetail">
        <div class="detail-title">{{ pageData.title }}</div>
        <div class="color-1">
          <span class="pr20"
            >{{ $t("page.content.source") }}：{{ $t("page.content.add") }}</span
          >
          <span class="pr20"
            >{{ $t("page.content.author") }}：{{ pageData.author }}</span
          >
          <span
            >{{ $t("page.content.publishDate") }}：{{
              moment(pageData.publishTime).format("YYYY-MM-DD HH:mm")
            }}</span
          >
        </div>
        <el-divider></el-divider>
        <div v-html="pageData.textContent" style="line-break: anywhere;"></div>
        <!-- 附件信息 -->
        <attachmentUpload
          class="pt20"
          :type="2"
          :fileData="fileData"
          :isShowDesc="source === '1'"
          v-if="fileData.length > 0"
        ></attachmentUpload>
      </div>
    </div>
  </div>
</template>

<script>
import { queryNoticeById, getFaqProblemById } from "@/app/shop/api/shoppingSP";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb";
import attachmentUpload from "@/basa/components/common/attachmentUpload1";
import moment from "moment";
// import $t from "@/app/shop/utils/translateUtil";
export default {
  name: "announcementDetail",
  components: {
    baseBreadCrumb,
    attachmentUpload
  },
  data() {
    return {
      moment: moment,
      pageData: {},
      currBreadCrumb: [{ title: "采购公告", path: "/procurementNotice" }],
      fileData: [],
      source: this.$route.query.source //1->供应商投标操作流程   else->公告详情
    };
  },
  activated() {
    if (this.source === "1") {
      this.currBreadCrumb.push({
        title: this.$t("page.content.supplierBiddingProcess")
      });
      this.initProcess();
    } else {
      this.currBreadCrumb.push({
        title: "业务公告",
        path: "/announcementsList"
      });
      // this.setBreadCrumb();
      this.init();
    }
  },
  deactivated() {
    this.currBreadCrumb = [{ title: "采购公告", path: "/procurementNotice" }];
  },
  computed: {},
  methods: {
    // $t, // 移植代码存在国际化方案临时解决
    init() {
      queryNoticeById({
        noticeInfoId: this.$route.query.id,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data["noticeInfoBO"];
          this.fileData = res.data.data.basFileRelationBOs.map(item => {
            item.uploadId = item.fileInfoId;
            item.fileSize = Math.round(item.fileSize / 1024);
            return item;
          });
          this.currBreadCrumb.push({ title: this.pageData.title });
        }
      });
    },
    initProcess() {
      getFaqProblemById({
        faqId: this.$route.query.id
      }).then(res => {
        let item = res.data.data.faqProblemBO;
        this.pageData = {
          title: item.faqName,
          author: item.publishUser,
          publishTime: item.publishTime,
          textContent: item.textContent
        };
        this.fileData = res.data.data.fileList;
      });
    },
    // setBreadCrumb() {
    //   const handlerClick = searchType => {
    //     const serchTypeMap = {
    //       首页: "",
    //       采购公告: "procurementNotice"
    //     };
    //     location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}/${
    //       serchTypeMap[searchType]
    //     }`;
    //   };
    //   const source = this.$route.query.searchType;
    //   if (this.$route.query.isJRZL === "1") {
    //     this.currBreadCrumb = [];
    //     this.currBreadCrumb.push({
    //       title: source,
    //       clickFn: this.$route.query.isJRZL === "1" ? handlerClick : null,
    //       to: "/"
    //     });
    //   }
    // },
    back() {
      const serchTypeMap = {
        首页: "",
        采购公告: "procurementNotice"
      };
      const searchType = this.$route.query.searchType;
      location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}/${
        serchTypeMap[searchType]
      }`;
    }
  }
};
</script>

<style scoped>
/*.ccui-home-app-container-detail {
  min-height: calc(100vh - 561px);
  margin: 0 auto 0 !important;
  padding: 0 0 0;
  min-width: 1180px;
}*/
</style>
